(function(){
  if(window.__nocteCart)return;window.__nocteCart=1;
  function openDrawer(){
    var c=document.querySelector('cart-drawer-component');
    if(c&&typeof c.open==='function'){c.open();return true}
    var t=document.getElementById('cart-drawer');
    if(t&&typeof t.showDialog==='function'){t.showDialog();return true}
    var d=document.querySelector('#cart-drawer dialog');
    if(d&&typeof d.showModal==='function'){if(!d.open)d.showModal();return true}
    return false;
  }
  document.addEventListener('submit',async function(e){
    var f=e.target;if(!f||!f.matches||!f.matches('form.n-buy-form, form.ws-form'))return;
    if(f.querySelector('[name="return_to"]'))return;
    if(!document.getElementById('cart-drawer'))return;
    e.preventDefault();
    var btn=f.querySelector('[type="submit"]');if(btn)btn.disabled=true;
    try{
      var fd=new FormData(f);fd.append('sections','cart-drawer-section');fd.append('sections_url',location.pathname);
      var r=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
      if(!r.ok)throw 0;
      var data=await r.json();
      var html=data.sections&&data.sections['cart-drawer-section'];
      if(html){var doc=new DOMParser().parseFromString(html,'text/html');var oi=document.querySelector('#cart-drawer .cart-drawer__inner'),ni=doc.querySelector('.cart-drawer__inner');if(oi&&ni&&oi.classList.contains('cart-drawer--empty')){oi.replaceWith(ni)}else{var nw=doc.querySelector('.cart-drawer__inner .cart-items-component'),old=document.querySelector('#cart-drawer .cart-drawer__inner .cart-items-component');if(nw&&old)old.replaceWith(nw)}}
      var cart=await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'nocte-buy',data:{source:'nocte-buy',itemCount:cart.item_count}}}));
      if(!openDrawer())location.href='/cart';
    }catch(err){f.submit()}
    finally{if(btn)btn.disabled=false}
  },true);
})();
